var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7297 2V3.62162M11.7297 20.3784V22M22 12H20.3784M3.62162 12H2M19.0711 19.0711L17.9244 17.9244M6.07559 6.07559L4.92893 4.92893M4.92894 19.0711L6.0756 17.9244M17.9244 6.0756L19.0711 4.92894M17.4054 12C17.4054 14.9853 14.9853 17.4054 12 17.4054C9.01468 17.4054 6.59459 14.9853 6.59459 12C6.59459 9.01468 9.01468 6.59459 12 6.59459C14.9853 6.59459 17.4054 9.01468 17.4054 12Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.0cf404c8f48f784c28dea8c563c079af.svg";
export { ForwardRef as ReactComponent };